import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#0A66C2",
        d: "M22.228.5H1.772A1.772 1.772 0 0 0 0 2.272v20.456A1.772 1.772 0 0 0 1.772 24.5h20.456A1.772 1.772 0 0 0 24 22.728V2.272A1.772 1.772 0 0 0 22.228.5ZM7.153 20.945H3.545V9.483h3.608v11.462ZM5.347 7.895a2.072 2.072 0 1 1 2.083-2.07 2.042 2.042 0 0 1-2.083 2.07Zm15.106 13.06h-3.606v-6.262c0-1.846-.785-2.416-1.799-2.416-1.07 0-2.12.806-2.12 2.463v6.215H9.32V9.492h3.47v1.588h.047c.348-.705 1.568-1.91 3.43-1.91 2.013 0 4.188 1.195 4.188 4.695l-.002 7.09Z"
      })
    ], -1 /* HOISTED */),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 .5h24v24H0z"
        })
      ])
    ], -1 /* HOISTED */)
  ])))
}
export default { render: render }